export enum SnShareStatus {
  Accepted = 'Accepted',
  Unaccepted = 'Unaccepted',
  Pending = 'Pending',
}
